import { limit, orderBy, query, where } from 'firebase/firestore'
import type {
  MutationRequestFilter,
  MutationRequestSort,
  MutationRequestStatus,
} from '~/features/MutationRequests/mutationRequestsModel'
import type { MedicationAgreementMutationRequest } from '~/models'
import { PaginatedArrayService } from './serviceLivePaginatedArray'

export class MedicationAgreementMutationRequestService extends PaginatedArrayService<MedicationAgreementMutationRequest> {
  constructor() {
    super('MedicationAgreementMutationRequests')
  }

  public listenForStatusAndAction(
    status: MutationRequestStatus,
    requestAction: MutationRequestFilter,
    sort: MutationRequestSort,
  ): void {
    const actionFilter
      = requestAction === 'all' ? ['update', 'delay', 'stop'] : [requestAction]

    const listenQuery = query(
      this.collection,
      where('Status', '==', status),
      where('RequestAction', 'in', actionFilter),
      orderBy(sort.fieldName, sort.direction),
      limit(this.FETCH_LIMIT),
    )

    this.listen(listenQuery)
  }
}
